// src/data/indianStates.js

// List of Indian States and Union Territories
export const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands", // Union Territory
    "Chandigarh",                 // Union Territory
    "Dadra and Nagar Haveli and Daman and Diu", // Union Territory
    "Delhi",                      // Union Territory (NCT)
    "Jammu and Kashmir",          // Union Territory
    "Ladakh",                     // Union Territory
    "Lakshadweep",                // Union Territory
    "Puducherry",                 // Union Territory
  ];
  
  // Sort alphabetically for better UX in the dropdown
  indianStates.sort();